import store from '../store'

export default{
    methods:{
        checkFeature: function (featureCode) {
            if (store.state.user.userType == "ADMIN") {//管理员类型不受角色权限控制
                return true;
            }
            if(!featureCode){
                return false;
            }
            //console.log("userf",store.state.userFeature);
            if(!store.state.userFeature){
                return false;
            }

            var featureStr = store.state.userFeature.join(" ");
            if(featureStr.indexOf(featureCode) != -1){
                return true;
            }else{
                return false;
            }
        },
        dateFormat:function (date,fmt) {
            var o = {
                "M+" : date.getMonth() + 1,
                "d+" : date.getDate(),
                "h+" : date.getHours(),
                "m+" : date.getMinutes(),
                "s+" : date.getSeconds(),
                "q+" : Math.floor((date.getMonth() + 3) / 3),
                "S" : date.getMilliseconds()
            };
            if (/(y+)/.test(fmt))
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o)
                if (new RegExp("(" + k + ")").test(fmt))
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            return fmt;
        },
        allReplace:function (obj, f,e) {
            var reg = new RegExp(f, "g");
            obj = obj+"";
            return obj.replace(reg, e);
        },
        dealWithDate(obj){
            obj = obj + "";
            if(obj.indexOf("/") != -1){
                obj = this.allReplace(obj,"/","-");
            }
            if(obj.indexOf("年") != -1){
                obj = this.allReplace(obj,"年","-");
            }
            if(obj.indexOf("月") != -1){
                obj = this.allReplace(obj,"月","-");
            }
            if(obj.indexOf("日") != -1){
                obj = this.allReplace(obj,"日","-");
            }
            obj = obj.split("-");
            if(obj.length<2){
                return "";
            }
            var date = new Date();
            date.setFullYear(parseInt(obj[0]));
            date.setMonth(parseInt(obj[1])-1);
            date.setDate(parseInt(obj[2]));
            obj = this.dateFormat(date, "yyyy-MM-dd");
            return obj;
        }
    }
}


// WEBPACK FOOTER //
// ./src/utill/authentication.js